import styled from '@emotion/styled';
import { createElement, FC } from 'react';
import { ResponsiveContainer, ResponsiveContainerProps } from 'recharts';

// Recharts のResponsive Container はwidth="100%" で使うと、画面サイズが小さくなった時に上手くresize してくれない
// 下記のIssue を参考にCustom Container を作成
// https://github.com/recharts/recharts/issues/1767#issuecomment-598607012

type Props = {
  className?: string;
} & Omit<ResponsiveContainerProps, 'id'>;

const RechartsResponsiveContainer: FC<Props> = (props) => {
  const { width, height, className, children } = props;
  return (
    <RelativeWrapper width={width} height={height} className={className}>
      <AbsoluteWrapper>
        <ResponsiveContainer {...props}>{children}</ResponsiveContainer>
      </AbsoluteWrapper>
    </RelativeWrapper>
  );
};

const RelativeWrapper = styled('div')<Props>((props: Props) => ({
  position: 'relative',
  width: props.width,
  height: props.height,
}));

const AbsoluteWrapper = styled('div')({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
});

export default RechartsResponsiveContainer;
